import React from 'react';
import { Link } from 'react-router-dom'; 
import { useTranslation } from 'react-i18next';
import './PrivacyPolicy.css'; // Importa tu archivo de estilos CSS

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  
  return (
    <div className="privacy-policy-container">
      <h1>{t("privacyNotice.title")}</h1>
      <p>
        <strong>{t("privacyNotice.effectiveDate")}</strong> {t("privacyNotice.date")}
      </p>
      
      <h2>{t("privacyNotice.section1.title")}</h2>
      <p>{t("privacyNotice.section1.content")}</p>
      
      <h3>{t("privacyNotice.section1_1.title")}</h3>
      <p>{t("privacyNotice.section1_1.content")}</p>
      <ul>
        {t("privacyNotice.section1_1.items", { returnObjects: true }).map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      
      <h2>{t("privacyNotice.section2.title")}</h2>
      <p>{t("privacyNotice.section2.content")}</p>
      <ul>
        {t("privacyNotice.section2.items", { returnObjects: true }).map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      
      <h2>{t("privacyNotice.section3.title")}</h2>
      <p>{t("privacyNotice.section3.content")}</p>
      
      <h2>{t("privacyNotice.section4.title")}</h2>
      <p>{t("privacyNotice.section4.content")}</p>
      
      <h2>{t("privacyNotice.section5.title")}</h2>
      <p>{t("privacyNotice.section5.content")}</p>
      
      <h2>{t("privacyNotice.section6.title")}</h2>
      <p>{t("privacyNotice.section6.content")}</p>
      <ul>
        <li>{t("privacyNotice.section6.website")} <a href="https://transmex.com.mx/">https://transmex.com.mx/</a></li>
      </ul>

      <Link to="/">{t("privacyNotice.back")}</Link>
    </div>
  );
}

export default PrivacyPolicy;